module.exports = __webpack_public_path__ + "static/media/microsoft.de54cdbd.svg";